
const payUUrl = process.env.PAYU_TEST;
const merchantKey = process.env.PAYU_KEY;
const merchantSecret = process.env.PAYU_SECRET;

async function generateSignature(secret, date) {
  try {
    const encoder = new TextEncoder();
    const data = encoder.encode(date);

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      encoder.encode(secret),
      { name: "HMAC", hash: "SHA-512" },
      false,
      ["sign"]
    );

    const sig = await crypto.subtle.sign("HMAC", cryptoKey, data);

    return btoa(String.fromCharCode(...new Uint8Array(sig)));
  } catch (err) {
    console.error("Failed to generate signature.", err);
    return null;
  }
}

export async function refundTransactions(payuDetails) {
  const dateHeader = new Date().toUTCString();
  const signature = await generateSignature(merchantSecret, dateHeader);

  if (!signature) return;

  const headers = {
    "Content-Type": "application/json",
    date: dateHeader,
    Authorization: `hmac username="${merchantKey}", algorithm="sha512", headers="date", signature="${signature}"`,
  };

  const body = {
    payuId: payuDetails.payuId,
    refundToken: payuDetails.refundToken,
    amount: payuDetails.amount,
    refundDetails: payuDetails.refundDetails || {},
    refundSplitRequest: null,
  };

  try {
    const response = await fetch(`${payUUrl}/v2/refund/`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Refund API error:", err);
    throw err;
  }
}
